import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import config from '../../config';
import { headers } from '../../token';
import Swal from 'sweetalert2';
import validateError from '../../ValidateError';
const server_backend = config.API_URL;

function CreateObject({ username }) {
    const [formData, setFormData] = useState({
        name: '',
        comment: '',
        user_transaction: username
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post(`${server_backend}/objects/insert`, formData, headers);

            if (response.data.RES_CODE === "00") {
                Swal.fire({
                    icon: 'success',
                    title: 'Created Successfully',
                    showConfirmButton: false,
                    timer: 2000
                });
                setFormData({
                    name: "",
                    comment: ""
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'There is already a Object with the same name, please try with another name',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const message = validateError(error);

            Swal.fire({
                icon: 'error',
                title: message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    };

    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xxl-6">
                        <div className="card">
                            <div className="card-header align-items-center d-flex">
                                <Link className='btn btn-warning' to="/Objects">
                                    Go Back
                                </Link>
                            </div>

                            <div className="card-body">

                                <center>
                                    <i class="ri-function-fill" style={{ fontSize: "70px", opacity: "0.8" }}></i>
                                    <p className="text-muted">
                                        Corresponding form to create the Object
                                    </p>
                                </center>

                                <div className="live-preview">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label htmlFor="name" className="form-label">Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="name"
                                                        name="name"
                                                        value={formData.name}
                                                        onChange={handleChange}
                                                        required />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label htmlFor="comment" className="form-label">Comment</label>
                                                    <textarea
                                                        className="form-control"
                                                        placeholder="Enter comment"
                                                        id="comment"
                                                        name="comment"
                                                        value={formData.comment}
                                                        onChange={handleChange}
                                                    ></textarea>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label htmlFor="user_transaction" className="form-label">User Transaction</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter user transaction"
                                                        id="user_transaction"
                                                        value={username}
                                                        name="user_transaction"
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="text-end">
                                                    <button type="submit" className="btn btn-primary">Submit</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreateObject;
